import Vue from 'vue'
import { config } from './configs/hosts'

const Configurator = {

  install (Vue) {
    const h = config()
    Vue.getBusinessHost = function () {
      return h.business
    }
    Vue.getAdminHost = function () {
      return h.admin
    }
    Vue.getIdentityHost = function () {
      return h.identity
    }
    Vue.getSignalRHost = function () {
      return h.signalR
    }
    Vue.getCurrentHost = function () {
      return h.current
    }
  }
}

Vue.use(Configurator)

// export default HostsConfigurator
